import axios from 'axios';

const api_url = process.env.REACT_APP_API_URL;

// Function to get v2 API URL by replacing /v1/ with /v2/ in the base API URL
const getApiUrlV2 = () => {
    // If api_url includes /v1/, replace it with /v2/
    // This handles the case where REACT_APP_API_URL includes the version
    if (api_url && api_url.includes('/v1/')) {
        return api_url.replace('/v1/', '/v2/');
    }
    // If api_url doesn't have a version, assume it's a base URL and add /v2/
    return `${api_url || ''}v2/`;
};

// Minimal type for remote organization info
export interface RemoteOrganizationInfo {
    ats_id: string;
    organization_id: string;
    [key: string]: any;
}

// Get current remote organization info (ATS ID and organization ID)
export const getCurrentRemoteOrganizationInfo = async () => {
    return await axios.get<RemoteOrganizationInfo>(`${getApiUrlV2()}ats/organization-info/`);
};

// Get remote organization permissions settings
export const getRemoteOrganizationSettings = async (atsId: string, organizationId: string) => {
    return await axios.get(`${getApiUrlV2()}ats/connections/${atsId}-${organizationId}/organization/`);
};

// Update remote organization permissions settings
export const updateRemoteOrganizationSettings = async (
    atsId: string,
    organizationId: string,
    extendedData: any
) => {
    return await axios.patch(
        `${getApiUrlV2()}ats/connections/${atsId}-${organizationId}/organization/`,
        { extended_data: extendedData }
    );
};

// Fetch SmartRecruiters roles for a given org (via Kombo passthrough)
export const getSmartRecruitersRoles = async (atsId: string, organizationId: string) => {
    // DRF detail route requires a pk, but we don't use it (set to 0)
    return await axios.get(`${getApiUrlV2()}ats/connections/${atsId}-${organizationId}/organization/0/smartrecruiters-roles/`);
};

// Fetch Recruitee roles for a given org (via Kombo passthrough)
export const getRecruiteeRoles = async (atsId: string, organizationId: string) => {
    // DRF detail route requires a pk, but we don't use it (set to 0)
    return await axios.get(`${getApiUrlV2()}ats/connections/${atsId}-${organizationId}/organization/0/recruitee-roles/`);
};

// Get default permissions for roles from backend
export const getDefaultPermissions = async () => {
    return await axios.get(`${getApiUrlV2()}ats/default-permissions/`);
}; 